import type { ClientContextValue } from "@app/portal-sdk";

/**
 * SET-1: the client settings section. One place for the things that
 * configure this client, at /c/:slug/settings, with a sub-navigation. Which
 * entries a person sees follows what the API already enforces: Reference
 * data is visible to any member and editable by canManage; Team and Regional
 * and fiscal are canManage. A person who can reach nothing sees no gear.
 */
export type SettingsSection = {
  key: "reference" | "regional" | "team" | "activity";
  label: string;
  description: string;
};

const ALL: (SettingsSection & { manage: boolean })[] = [
  { key: "reference", label: "Reference data", description: "The lists behind every dropdown in every application: your words, the lists your applications keep, and the standards.", manage: false },
  { key: "regional", label: "Regional and fiscal", description: "The fiscal year, the currency, the locale, the time zone and how dates are shown.", manage: true },
  { key: "team", label: "Team", description: "Who has access to this client portal, and with what role.", manage: true },
  // CORE-1: the client's own activity log, the history core does not otherwise keep.
  { key: "activity", label: "Activity", description: "Who changed what, and when: settings, lists, data, invitations and files.", manage: true }
];

export const settingsSections = (ctx: Pick<ClientContextValue, "canManage">): SettingsSection[] =>
  ALL.filter((s) => !s.manage || ctx.canManage).map(({ manage: _m, ...s }) => s);

export const settingsPath = (slug: string, key?: SettingsSection["key"]) => `/c/${slug}/settings${key ? `/${key}` : ""}`;
